<template>
  <transition name="dd-fade">
    <div v-if="open" class="dd-overlay" @click.self="close">
      <div class="dd-modal" role="dialog" aria-modal="true">
        <header class="dd-header">
          <div>
            <span class="dd-eyebrow">DETALHE</span>
            <h3 class="dd-title">{{ title }}</h3>
          </div>
          <button type="button" class="dd-close" @click="close" aria-label="Fechar">
            <i class="bx bx-x"></i>
          </button>
        </header>

        <div class="dd-body">
          <div v-if="loading" class="dd-loading">Carregando leituras…</div>
          <div v-else-if="error" class="dd-error"><i class="bx bx-error-circle"></i> {{ error }}</div>
          <div v-else-if="!result || !result.rows.length" class="dd-empty">Nenhuma leitura encontrada para este detalhe.</div>
          <div v-else>
            <div class="dd-meta">{{ result.rows.length }} leituras · gerado em {{ result.meta.execution_ms }}ms</div>
            <table class="dd-table">
              <thead>
                <tr>
                  <th v-for="col in result.columns" :key="col.alias">{{ col.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in result.rows" :key="i">
                  <td v-for="col in result.columns" :key="col.alias">{{ row[col.alias] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <footer class="dd-footer">
          <button type="button" class="dd-btn" @click="close">Fechar</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import services from '../services'

export default {
  name: 'drill-dialog',
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: 'Leituras detalhadas' },
    rowFilters: { type: Object, default: () => ({}) },
    baseFilters: { type: Object, default: () => ({}) }
  },
  data: () => ({
    loading: false,
    error: null,
    result: null
  }),
  watch: {
    open (val) {
      if (val) this.fetch()
      else { this.result = null; this.error = null }
    }
  },
  methods: {
    close () { this.$emit('close') },
    fetch () {
      this.loading = true
      this.error = null
      this.result = null
      services.reportDrill({
        row_filters: this.rowFilters,
        base_filters: this.baseFilters,
        limit: 200
      })
        .then((res) => { this.result = res.data; this.loading = false })
        .catch((err) => {
          const msg = (err && err.response && err.response.data && err.response.data.message) ||
                      (err && err.message) ||
                      'Erro ao carregar detalhe.'
          this.error = msg
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.dd-overlay {
  position: fixed; inset: 0; z-index: 1200;
  background: rgba(20, 24, 38, 0.6);
  display: grid; place-items: center; padding: 24px;
}
.dd-modal {
  width: 100%; max-width: 800px; max-height: 88vh;
  background: #fff; border-radius: 12px;
  box-shadow: 0 24px 64px rgba(0,0,0,0.3);
  display: flex; flex-direction: column; overflow: hidden;
}
.dd-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 20px 24px; border-bottom: 1px solid #eaecf2;
}
.dd-eyebrow { font-size: 10px; font-weight: 700; letter-spacing: 1.5px; color: #8b90a5; text-transform: uppercase; }
.dd-title { font-size: 18px; font-weight: 600; color: #1a1d26; margin: 4px 0 0; }
.dd-close {
  background: transparent; border: 0; padding: 6px; cursor: pointer;
  font-size: 22px; color: #8b90a5; border-radius: 6px;
  &:hover { background: #f5f6fa; color: #1a1d26; }
}

.dd-body { flex: 1; overflow-y: auto; padding: 16px 24px; }
.dd-loading, .dd-empty { color: #8b90a5; font-size: 13px; padding: 16px 0; }
.dd-error {
  display: flex; align-items: center; gap: 8px;
  background: #fef2f2; color: #c62828; border: 1px solid #fecaca;
  border-radius: 8px; padding: 12px; font-size: 13px;
}
.dd-meta { font-size: 11px; color: #8b90a5; margin-bottom: 8px; }
.dd-table {
  width: 100%; border-collapse: collapse; font-size: 12px;
  th, td { padding: 8px 10px; text-align: left; border-bottom: 1px solid #eaecf2; }
  th { background: #f7f8fb; color: #4a5068; font-weight: 600; position: sticky; top: 0; }
  td { color: #1a1d26; }
}

.dd-footer { padding: 14px 24px; border-top: 1px solid #eaecf2; display: flex; justify-content: flex-end; }
.dd-btn {
  padding: 8px 16px; border-radius: 8px; border: 1px solid #d8dbe4;
  background: #fff; color: #4a5068; font-size: 13px; cursor: pointer;
  &:hover { background: #f5f6fa; }
}

.dd-fade-enter-active, .dd-fade-leave-active { transition: opacity 0.18s ease; }
.dd-fade-enter, .dd-fade-leave-to { opacity: 0; }
</style>
